import React from 'react'
import ChecklistCheckbox from './ChecklistCheckbox'
import Tooltip from '../Tooltip'
import ShopOrderTooltip from './tooltips/ShopOrderTooltip'
import CustomerTooltip from './tooltips/CustomerTooltip'
import ShopTooltip from './tooltips/ShopTooltip'
import { BORDER_STYLE } from './SortableOrdersTable'
import { displayField, displayCurrency } from '../../utils/utils'
import { Table } from 'semantic-ui-react'
import $ from 'jquery'
import {
  DETAILS_TAB, SERVICES_TAB, NOTES_TAB, ISSUES_TAB, TRANSACTIONS_TAB
} from "../../constants/orders"
import ShopOrderDetails from "./ShopOrderDetails";
import {GREEN} from "../../constants/colors";

export default class OrderRow extends React.Component {
  // TODO: refactor this hack
  closeTooltip = () => {
    $(`.OrderRow-${this.props.order.id}`).click()
  }

  handleChecklistSubmit = (order, internalNotes, checklistItem) => {
    const { id, checklist } = order

    this.props.updateOrder(
      { id: id, checklist: { ...checklist, ...checklistItem }, internal_notes: internalNotes }
    )
    this.closeTooltip()
  }

  render() {
    const { order, originator, vehicle, shop, orderServices, checklistItems, isLastRow, version } = this.props
    const { appointment_datetime, post_tax_total, status, created_at, previous_payments, total_from_cart } = order
    const membership = originator.active_membership

    const style = isLastRow ? {borderBottom: BORDER_STYLE} : {}
    const tabData = [
      { tab: DETAILS_TAB, label: "Details" },
      { tab: SERVICES_TAB, label: "Services" },
      { tab: NOTES_TAB, label: "Internal Notes" },
      { tab: ISSUES_TAB, label: "Issues" },
      { tab: TRANSACTIONS_TAB, label: "Transactions" },
    ]

    return (
      <Table.Row key={`OrderRow-${order.id}`} className={`OrderRow-${order.id}`}>
          <Table.Cell className="left aligned" style={{...style, cursor: "pointer"}}>
              {version === 'V1' && <ShopOrderTooltip
                  order={order}
                  customer={originator}
                  vehicle={vehicle}
                  shop={shop}
                  orderServices={orderServices}
                  tabData={tabData}
                  id={order.id}
              />}
              {version === 'V2' && <Tooltip
                  trigger={<span>{order.id}</span>}
                  content={
                      <div style={{width: order.is_fixed_price ? "850px" : "750px", cursor: "auto", minHeight: "20px"}}>
                          <ShopOrderDetails id={order.id} customer={originator} tabData={tabData}/>
                      </div>
                  }
                  infoIcon
                  infoIconColor={order.is_fixed_price ? GREEN : 'black'}
              />}
          </Table.Cell>
        <Table.Cell style={{...style, cursor: "pointer"}}>
          <Tooltip
            trigger={<span>{`${originator.full_name} (${originator.completed_orders_count})`}</span>}
            content={<CustomerTooltip customer={originator} />}
            infoIcon
            infoIconColor={membership && membership.price > 0 ? 'blue' : 'black'}
          />
        </Table.Cell>
        <Table.Cell style={style}>{appointment_datetime}</Table.Cell>
        {checklistItems.map((item, i) => {
          return (
            <Table.Cell style={style} key={`checklist-${item.name}-${order.id}`}>
              <ChecklistCheckbox
                order={order}
                internalNotes={order.internal_notes}
                name={item.name}
                label={item.label}
                checklist={order.checklist}
                adminUser={this.props.adminUser}
                handleSubmit={this.handleChecklistSubmit}
                closeTooltip={this.closeTooltip}
              />
            </Table.Cell>
          )
        })}
        <Table.Cell style={style}>
          {displayCurrency(total_from_cart)}
        </Table.Cell>
        <Table.Cell style={style}>
          {displayCurrency(post_tax_total)}
        </Table.Cell>
        <Table.Cell style={style}>
          {displayCurrency(previous_payments)}
        </Table.Cell>
        <Table.Cell style={style}>{status}</Table.Cell>
        <Table.Cell style={{...style, cursor: "pointer"}}>
            {version === 'V1' && <Tooltip
                trigger={
                    <span>
                {`${displayField(shop.company_name)} (${displayField(shop.completed_orders_count)})`}
                </span>
                }
                content={<ShopTooltip shop={shop} order={order} />}
                infoIcon
            />}
            {version === 'V2' && <p>{displayField(order.shop_name)} ({displayField(order.shop_count)})</p>}
        </Table.Cell>
        <Table.Cell style={{...style, borderRight: BORDER_STYLE}}>{created_at}</Table.Cell>
      </Table.Row>
    )
  }
}
